module.exports = __webpack_public_path__ + "img/management1.f7dad442.png";